<style src="./PermissionMap.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="permission">
    <ul class="grid-list-container">
      <li class="grid-list-header">
        <ul>
          <li class="col-9">Setor</li>
          <li class="col-1 center">Show</li>
          <li class="col-1 center">Ler</li>
          <li class="col-1 center">Cria</li>
          <li class="col-1 center">Edita</li>
          <li class="col-1 center">Deleta</li>
        </ul>
      </li>

      <li class="grid-list-item" v-for="sector, sectorIdx in permissionMapModel" :key="sectorIdx">
        <ul>
          <li class="col-9">{{ sector.label }}</li>
          <li class="col-1 center"><input type="checkbox" class="checkbox" v-model="permissionMapModel[sectorIdx].SHOW" @click="saveChanges" /></li>
          <li class="col-1 center"><input type="checkbox" class="checkbox" v-model="permissionMapModel[sectorIdx].READ" v-if="permissionMapModel[sectorIdx].READ !== undefined" @click="saveChanges" /></li>
          <li class="col-1 center"><input type="checkbox" class="checkbox" v-model="permissionMapModel[sectorIdx].CREATE" v-if="permissionMapModel[sectorIdx].CREATE !== undefined" @click="saveChanges" /></li>
          <li class="col-1 center"><input type="checkbox" class="checkbox" v-model="permissionMapModel[sectorIdx].EDIT" v-if="permissionMapModel[sectorIdx].EDIT !== undefined" @click="saveChanges" /></li>
          <li class="col-1 center"><input type="checkbox" class="checkbox" v-model="permissionMapModel[sectorIdx].DELETE" v-if="permissionMapModel[sectorIdx].DELETE !== undefined" @click="saveChanges" /></li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script>
import {GetPermissionSectorList, EditPermission, ReadPermissionDetailsById} from '@/brain/record/permission'

export default {
  name: 'Occupation',
  props: {
    permissionId: {
      default: null
    }
  },
  data () {
    return {
      sectorList: [],
      permissionMapModel: {}
    }
  },
  watch: {
    permissionId (pId) {
      const id = pId.value
      this.permissionMapModel = this.sectorList
      ReadPermissionDetailsById({id})
        .then((result) => {
          for (let permissionItem in result.permissions) {
            if (result.permissions[permissionItem].includes('ALL')) {
              const allTrue = {
                SHOW: true,
                READ: true,
                CREATE: true,
                DELETE: true,
                EDIT: true
              }
              Object.assign(this.permissionMapModel[permissionItem], allTrue)
            } else {
              const allFalse = {
                SHOW: false,
                READ: false,
                CREATE: false,
                DELETE: false,
                EDIT: false
              }
              Object.assign(this.permissionMapModel[permissionItem], allFalse)
              for (let sector in result.permissions[permissionItem]) {
                this.permissionMapModel[permissionItem][result.permissions[permissionItem][sector]] = true
              }
            }
          }
        })
    }
  },
  mounted () {
    this.getPermissionSectorList()
  },
  methods: {
    getPermissionSectorList () {
      GetPermissionSectorList()
      .then((result) => {
        const sectorModified = {}
        for (let item in result.result) {
          const sectorName = result.result[item].sectorName
          const sectorLabel = result.result[item].identity
          const sectorActions = result.result[item].actions
          const sectorActionsMerged = {}
          for (let itemSector in sectorActions) {
            sectorActionsMerged[sectorActions[itemSector]] = false
          }
          sectorModified[sectorName] = sectorActionsMerged
          sectorModified[sectorName].label = sectorLabel
        }
        this.sectorList = sectorModified
        this.permissionMapModel = sectorModified
      })
    },
    saveChanges () {
      this.$nextTick(() => {
        const pMap = this.permissionMapModel
        const editableMap = this.editMap(pMap)
        const editData = {
          id: this.permissionId.value,
          permissions: editableMap
        }
        EditPermission(editData)
          .then((result) => {})
      })
    },
    editMap (pMap) {
      const edited = {}
      for (let itemEdit in pMap) {
        const mappedPermissions = this.getAllMapped(pMap[itemEdit])
        edited[itemEdit] = mappedPermissions
      }
      return edited
    },
    getAllMapped (pSectors) {
      const SHOW = pSectors && pSectors.SHOW !== undefined ? pSectors.SHOW : false
      const READ = pSectors && pSectors.READ !== undefined ? pSectors.READ : false
      const CREATE = pSectors && pSectors.CREATE !== undefined ? pSectors.CREATE : false
      const EDIT = pSectors && pSectors.EDIT !== undefined ? pSectors.EDIT : false
      const DELETE = pSectors && pSectors.DELETE !== undefined ? pSectors.DELETE : false

      let sectorMapped = []

      if (SHOW) sectorMapped.push('SHOW')
      if (READ) sectorMapped.push('READ')
      if (CREATE) sectorMapped.push('CREATE')
      if (EDIT) sectorMapped.push('EDIT')
      if (DELETE) sectorMapped.push('DELETE')

      return sectorMapped.length === 5 || pSectors.ALL ? ['ALL'] : sectorMapped
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/permission/permission-map/PermissionMap.vue